import React, { useEffect } from "react";
import "./sidebar.scss";
import { Link } from "react-router-dom";
import useMediaQuery from "@mui/material/useMediaQuery";
import brandStore from "../../stores/brandStore";

// Icons
import CategoryIcon from "@mui/icons-material/Category";
import SpaceDashboardIcon from "@mui/icons-material/SpaceDashboard";
import InventoryIcon from "@mui/icons-material/Inventory";
import LocalOfferRoundedIcon from "@mui/icons-material/LocalOfferRounded";
import ShoppingBagRoundedIcon from "@mui/icons-material/ShoppingBagRounded";
import GroupRoundedIcon from "@mui/icons-material/GroupRounded";
import ReplyAllRoundedIcon from "@mui/icons-material/ReplyAllRounded";
import ContactMailRoundedIcon from "@mui/icons-material/ContactMailRounded";
import CollectionsIcon from '@mui/icons-material/Collections';

// Images
import logo from "../../assets/logo.jpg";
import sidebarActivePage from "../../stores/sidebarActivePage";
import { BRAND_IMAGE_URL } from "../../constant";

// Menu List
const MenuList = [
  {
    name: "OVERVIEW",
    data: [
      {
        title: "Dashboard",
        to: "/dashboard",
        icon: <SpaceDashboardIcon className="icon" />,
      },
    ],
  },
  {
    name: "MANAGEMENT",
    data: [
      {
        title: "Category",
        to: "/category",
        icon: <CategoryIcon className="icon" />,
      },
      {
        title: "Product",
        to: "/product",
        icon: <InventoryIcon className="icon" />,
      },
      {
        title: "Orders",
        to: "/orders",
        icon: <ShoppingBagRoundedIcon className="icon" />,
      },
      {
        title: "Return Order Request",
        to: "/order-return-request",
        icon: <ReplyAllRoundedIcon className="icon" />,
      },
      {
        title: "Coupon",
        to: "/coupon",
        icon: <LocalOfferRoundedIcon className="icon" />,
      },
      {
        title: "Users",
        to: "/users",
        icon: <GroupRoundedIcon className="icon" />,
      },
      {
        title: "Contact Us Via",
        to: "/contact-us-via",
        icon: <ContactMailRoundedIcon className="icon" />,
      },
      {
        title: "Hero Section",
        to: "/hero-management",
        icon: <CollectionsIcon className="icon" />,
      },
    ],
  },
];

const Sidebar = ({ isOpenSidebar, setIsOpenSidebar }) => {
  const matches = useMediaQuery("(min-width:600px)");
  const max_width890 = useMediaQuery("(max-width:890px)");
  const max_width790 = useMediaQuery("(max-width:790px)");
  const max_width500 = useMediaQuery("(max-width:500px)");
  const BrandStore = brandStore();
  const SidebarActivePage = sidebarActivePage();

  useEffect(() => {
    if (matches === false) {
      setIsOpenSidebar(false);
    } else {
      setIsOpenSidebar(true);
    }
  }, [matches]);

  return (
    <>
      {/* {isOpenSidebar && ( */}
      <div
        className="sidebar grid"
        style={{
          width: isOpenSidebar
            ? max_width500
              ? "20%"
              : max_width790
                ? "15%"
                : max_width890
                  ? "10%"
                  : "20%"
            : "0",
        }}
      >
        <Link
          to="/dashboard"
          onClick={() => {
            if (matches === false) {
              setIsOpenSidebar(false);
            }
          }}
        >
          <div className="logoDiv flex">
            <div className="img-div">
              <img
                src={`${BRAND_IMAGE_URL}/${BrandStore.brand.brandLogo}`}
                alt="Logo"
              />
            </div>
            <h2>{BrandStore.brand.brandName}</h2>
          </div>
        </Link>

        <div className="menuDiv">
          {MenuList.map((maniItem) => (
            <div key={maniItem.name}>
              <div className="divTitle">{maniItem.name}</div>
              <ul className="menuLists grid">
                {maniItem.data.map((item) => (
                  <li className="listItem" key={item.title}>
                    <Link
                      to={item.to}
                      onClick={() => {
                        if (matches === false) {
                          setIsOpenSidebar(false);
                        }
                      }}
                      className="menuLink flex"
                      style={{
                        color:
                          SidebarActivePage.isActive === item.title &&
                          "hsl(94, 59%, 35%)",
                      }}
                    >
                      {item.icon}
                      <span className="smallTitle">{item.title}</span>
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
      {/* )} */}
    </>
  );
};

export default Sidebar;
